const formatNumber = (value) => Number(value ?? 0).toLocaleString("id-ID")

const formatCurrency = (value) =>
    new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(Number(value ?? 0))

const KpiCard = ({ label, value, sublabel, accent = "neutral", isLoading = false, format = "number" }) => {
    const accentClass =
        accent === "positive"
            ? "text-emerald-700"
            : accent === "negative"
                ? "text-rose-600"
                : accent === "warning"
                    ? "text-amber-600"
                    : "text-neutral-900"

    const formatted =
        format === "currency"
            ? formatCurrency(value)
            : format === "raw"
                ? value
                : formatNumber(value)

    return (
        <div className="p-4 bg-white border border-neutral-200 rounded-2xl">
            <div className="text-xs font-semibold tracking-wide text-neutral-500">{label}</div>
            <div className={`mt-2 text-2xl font-semibold ${accentClass}`}>
                {isLoading ? <span className="text-neutral-300">···</span> : formatted}
            </div>
            {sublabel ? <div className="mt-1 text-xs text-neutral-400">{sublabel}</div> : null}
        </div>
    )
}

export default KpiCard
